// 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start
import { FC, useState, useEffect } from 'react';
import { useAppDispatch } from 'hooks';
import { useSelector } from 'react-redux';
import { Upload } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import ButtonSubmit from 'components/Forms/ButtonSubmit';
import { PlusOutlined } from '@ant-design/icons';
import type { UploadFile } from 'antd/es/upload/interface';
import { Button, Modal } from 'components';
import { FormikProvider, useFormik } from 'formik';
import { Form } from 'formik-antd';
import { educationService } from 'services';
import { userData } from 'pages/Login/selectors';
import { creatPhoto } from 'utils';
import { SupportSite } from 'constant';
import { educationSendphoto } from 'pages/NewentrantSendoff/thunk';
import { SendPhotoStyled } from './styles';

type newAndSendFlg = {
  newcomer_education_status: string;
  sendoff_education_status: string;
};

const SendPhoto: FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const params: any = location.state;
  let education_status: any = null;
  if (params && params.education_status) {
    education_status = params.education_status;
  }
  const { user_id } = useSelector(userData);
  const [imageUrl, setImageUrl] = useState<string>();
  const [companyName, setCompanyName] = useState<string>();
  const [workerName, setWorkerName] = useState<string>();
  const [selectPopu, setSelectPopu] = useState<boolean>(false);
  const [newPopu, setNewPopu] = useState<boolean>(false);
  const [sendPopu, setSendPopu] = useState<boolean>(false);
  const [buttonFlg, setButtonFlg] = useState<boolean>(true);
  const [filePhoto, setFilePhoto] = useState<any>();
  const [newAndSendFlg, setNewAndSendFlg] = useState<newAndSendFlg>();

  useEffect(() => {
    if (!education_status) return;
    setCompanyName(education_status.company_name);
    setWorkerName(education_status.worker_name);
  }, [education_status]);

  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  const beforUpload = (file: any) => {
    if (file.type != 'image/jpg' && file.type != 'image/jpeg') {
      setSelectPopu(true);
      return false;
    }
    setFilePhoto(file);
    // 2024/03/15 Leading Win 障害対応 No40 start
    creatPhoto(file, 1280, 960)
      // 2024/03/15 Leading Win 障害対応 No40 end
      .then((url) => {
        setImageUrl(url as string);
        setButtonFlg(false);
      })
      .catch((e) => {
        console.log(e);
      });
    return false;
  };

  const formik = useFormik({
    initialValues,
    async onSubmit(values) {
      const result = await educationService.getEducationStatus({
        user_id: +education_status.users_id,
        cooperator_code: `${education_status.gyosya_code}-${education_status.gyosya_siten_code}`,
        site_id: +education_status.site_id,
      });
      await setNewAndSendFlg({
        newcomer_education_status: `${result.data.newcomer_education_status}`,
        sendoff_education_status: `${result.data.sendoff_education_status}`,
      });
      if (
        education_status.education_difference === '1' &&
        `${result.data.newcomer_education_status}` === '2'
      ) {
        setNewPopu(true);
        return null;
      }
      if (
        education_status.education_difference === '2' &&
        `${result.data.sendoff_education_status}` === '2'
      ) {
        setSendPopu(true);
        return null;
      }

      if (!user_id || !imageUrl) return;
      await dispatch(
        educationSendphoto({
          user_id: user_id,
          user_j_id: +education_status.users_id,
          site_id: +education_status.site_id,
          gyosya_code: education_status.gyosya_code,
          gyosya_siten_code: education_status.gyosya_siten_code,
          education_class: education_status.education_difference,
          image_binary: imageUrl,
          image_lat: 0,
          image_lng: 0,
        })
      );
      history.push({
        pathname: SupportSite.EducationStatus,
        state: { send_image_flg: '1' },
      });
    },
  });

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}></div>
    </div>
  );

  return (
    <SendPhotoStyled>
      <Modal
        title={
          <div className="appPopuSty">
            <div>添付できるファイルは、「jpg」もしくは「jpeg」ファイルのみです。</div>
          </div>
        }
        visible={selectPopu}
        width={640}
        okButton={{
          text: '閉じる',
          onClick: async () => {
            setSelectPopu(false);
          },
        }}
      ></Modal>
      <Modal
        title={
          <div className="appPopuSty">
            <div>新規入場者教育が既に承認済の為、実施することが出来ません</div>
          </div>
        }
        visible={newPopu}
        width={640}
        okButton={{
          text: '閉じる',
          onClick: async () => {
            setNewPopu(false);
            history.push({
              pathname: SupportSite.EducationStatus,
              state: { send_image_flg: '1' },
            });
          },
        }}
      ></Modal>
      <Modal
        title={
          <div className="appPopuSty">
            <div>送り出し教育が既に承認済の為、実施することが出来ません。</div>
          </div>
        }
        visible={sendPopu}
        width={640}
        okButton={{
          text: '閉じる',
          onClick: async () => {
            setSendPopu(false);
            history.push({
              pathname: SupportSite.EducationStatus,
              state: { send_image_flg: '1' },
            });
          },
        }}
      ></Modal>
      <div className="body">
        <div className="title">画像添付</div>
        <div className="tableSty">
          <div>会社名：{companyName ? companyName : ''}</div>
          <div>氏名　：{workerName ? workerName : ''}</div>
        </div>
        <FormikProvider value={formik}>
          <Form className="formStyle">
            <div className="photoSty">
              <div>画像　：</div>
              <Form.Item name="photo" className="photoSelect">
                <Upload
                  name="photo"
                  listType="picture-card"
                  className="avatar-uploader"
                  multiple={true}
                  showUploadList={false}
                  beforeUpload={beforUpload}
                >
                  {imageUrl ? (
                    <img src={imageUrl} alt="avatar" style={{ width: '100%' }} />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </Form.Item>
            </div>
            <div className="buttonSty">
              <Button
                onClick={() => {
                  history.push({
                    pathname: SupportSite.EducationStatus,
                    state: { send_image_flg: '0' },
                  });
                }}
              >
                キャンセル
              </Button>
              <ButtonSubmit disabled={buttonFlg}>送信</ButtonSubmit>
            </div>
          </Form>
        </FormikProvider>
      </div>
    </SendPhotoStyled>
  );
};

const initialValues = {
  photo: '',
};

export default SendPhoto;

// 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end
